import React from 'react';
import { FadeInUp, SectionLabel, AccentLine, StaggerContainer, StaggerItem } from './AnimationWrappers';

const BRANDS = [
  { name: 'Coolibar', specialty: 'UPF 50+ Sun-Protective Apparel' },
  { name: 'Skechers', specialty: 'Technical Activewear & Performance Knits' },
  { name: 'Little Green Radicals', specialty: 'GOTS-Certified Organic Childrenswear' },
  { name: 'Armtec', specialty: 'Tactical Gear & Ballistic-Rated Garments' },
  { name: 'Militar Shop', specialty: 'Combat Uniforms & Field Equipment' },
  { name: 'Moesa Reflect', specialty: 'EN 20471 Certified Hi-Vis Workwear' },
];

const BrandPortfolioSection = () => {
  return (
    <section id="brands" data-testid="brands-section" className="relative overflow-hidden" style={{ background: '#FAF8F5', padding: '70px 0' }}>
      <div className="container-main text-center">
        <SectionLabel number="07" title="Brand Portfolio" />
        <FadeInUp>
          <AccentLine />
          <h2 className="font-display mb-3" style={{ fontSize: '2.8rem', fontWeight: 700, color: '#1C1C1E' }}>
            Brand <span style={{ color: '#C8102E' }}>portfolio.</span>
          </h2>
          <p className="font-body mb-14 mx-auto" style={{ fontSize: '1.05rem', color: '#6B6B6F', maxWidth: '500px' }}>
            Trusted by performance brands where specification compliance is non-negotiable.
          </p>
        </FadeInUp>

        <StaggerContainer className="grid grid-cols-2 md:grid-cols-3 mx-auto" style={{ gap: '14px', maxWidth: '900px' }}>
          {BRANDS.map((brand, i) => (
            <StaggerItem key={i}>
              <div
                data-testid={`brand-${i}`}
                className="group relative text-left overflow-hidden transition-all duration-300 hover:-translate-y-1"
                style={{
                  background: '#FFFFFF',
                  borderRadius: '10px',
                  padding: '1.5rem 1.4rem',
                  minHeight: '120px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  border: '1px solid #E8E0D5',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                }}
              >
                {/* Red top accent on hover */}
                <div className="absolute top-0 left-0 right-0 h-[3px] opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: '#C8102E' }} />
                {/* Red left bar */}
                <div className="absolute top-0 left-0 w-[3px] h-full" style={{ background: '#C8102E' }} />
                <span className="font-display block mb-1" style={{ fontSize: '1.15rem', fontWeight: 700, color: '#1C1C1E', lineHeight: 1.3 }}>{brand.name}</span>
                <span className="font-mono" style={{ fontSize: '0.52rem', color: '#8A8A8E', textTransform: 'uppercase', letterSpacing: '0.08em', lineHeight: 1.6 }}>{brand.specialty}</span>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
      <div className="section-number">07</div>
    </section>
  );
};

export default BrandPortfolioSection;
